/**
 * PageLoader Component
 *
 * A full-page loading spinner used as a fallback for React.lazy() code splitting.
 * Shows a branded loading animation while route components are being loaded.
 */

import React from 'react';

const PageLoader = ({ message = 'Loading...' }) => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-gray-50">
      <div className="text-center">
        {/* Animated Spinner with brand colors */}
        <div className="relative w-16 h-16 mx-auto mb-4">
          {/* Outer ring */}
          <div className="absolute inset-0 rounded-full border-4 border-gray-200"></div>
          {/* Spinning gradient ring */}
          <div
            className="absolute inset-0 rounded-full border-4 border-transparent animate-spin"
            style={{
              borderTopColor: '#FFD200',
              borderRightColor: '#F7971E',
            }}
          ></div>
        </div>

        {/* Loading text */}
        <p className="text-gray-600 font-medium">{message}</p>

        {/* Subtle pulsing dots */}
        <div className="flex justify-center gap-1 mt-2">
          <span
            className="w-1.5 h-1.5 bg-[#F7971E] rounded-full animate-bounce"
            style={{ animationDelay: '0ms' }}
          ></span>
          <span
            className="w-1.5 h-1.5 bg-[#F7971E] rounded-full animate-bounce"
            style={{ animationDelay: '150ms' }}
          ></span>
          <span
            className="w-1.5 h-1.5 bg-[#F7971E] rounded-full animate-bounce"
            style={{ animationDelay: '300ms' }}
          ></span>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
